import { getSymbolHistory } from "../services/get-symbol-history";
import { getTradingViewConfig } from "../services/get-trading-view-config";
import { resolveSymbol } from "../services/resolve-symbol";
import { searchSymbols } from "../services/search-symbols";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  async onReady(callback: (config: any) => void) {
    const config = await getTradingViewConfig();
    setTimeout(() =>
      callback({
        ...config,
        symbols_types: [
          { name: "All", value: "" },
          { name: "Stock", value: "stock" },
          { name: "Forex", value: "forex" },
          // { name: "Crypto", value: "crypto" },
        ],
      })
    );
  },

  async searchSymbols(
    userInput: string,
    _exchange: string,
    symbolType: string,
    callback: (symbols: any[]) => void
  ) {
    const symbols = await searchSymbols({
      query: userInput,
      ...(symbolType ? { type: symbolType } : {}),
    });
    callback(symbols);
  },

  // symbolInfo template: {
  //   name: symbolName,
  //   timezone: "America/New_York",
  //   minmov: 1,
  //   minmov2: 0,
  //   pointvalue: 1,
  //   session: "0930-1600",
  //   has_intraday: false,
  //   visible_plots_set: "ohlc",
  //   type: "stock",
  //   pricescale: 100,
  //   ticker: symbolName,
  //   exchange: "NASDAQ",
  //   has_daily: true,
  //   format: "price",
  // };

  async resolveSymbol(
    symbolName: string,
    onSymbolResolvedCallback: (symbol: any) => void,
    onResolveErrorCallback: (error: string) => void
  ) {
    try {
      const symbolInfo = await resolveSymbol({ symbol: symbolName });
      onSymbolResolvedCallback({
        ...symbolInfo,
        name: symbolInfo.name ?? symbolName,

        timezone: symbolInfo.timezone ?? "America/New_York",
        // minmov: symbolInfo.minmov ?? 1,
        // minmov2: symbolInfo.minmov2 ?? 0,
        // pointvalue: symbolInfo.pointvalue ?? 1,
        pricescale: symbolInfo.pricescale ?? 100,
        session: symbolInfo.session ?? "0930-1600",
        has_intraday: symbolInfo.has_intraday ?? false,
        visible_plots_set: symbolInfo.visible_plots_set ?? "ohlcv",
        type: symbolInfo.type ?? "stock",
        ticker: symbolInfo.ticker ?? symbolName,
        // exchange: symbolInfo.exchange ?? "NASDAQ",
        has_daily: symbolInfo.has_daily ?? true,
        format: symbolInfo.format ?? "price",
      });
    } catch (error) {
      onResolveErrorCallback(error as string);
    }
  },

  async getBars(
    symbolInfo: any,
    resolution: string,
    periodParams: {
      countBack: number;
      to: number;
      from: number;
      firstDataRequest: boolean;
    },
    onHistoryCallback: (bars: any[], meta: any) => void
    // onErrorCallback: (error: string) => void
  ) {
    try {
      const barsData = await getSymbolHistory({
        symbol: symbolInfo.ticker,
        resolution: resolution,
        fromTime: periodParams.from,
        toTime: periodParams.to,
        countBack: periodParams.countBack,
      });

      // Transform the fetched data into the format required by onHistoryCallback

      const bars =
        barsData.c?.map((close, index) => ({
          time: (barsData.t?.[index] ?? 0) * 1000,
          open: barsData.o?.[index] || 100,
          high: barsData.h?.[index] || 100,
          low: barsData.l?.[index] || 100,
          volume: barsData.v?.[index] || 0,
          close,
        })) || [];

      // Return the bars to the library
      onHistoryCallback(bars, {
        noData: false,
      });
    } catch (error) {
      console.error("Error fetching bars:", error);
      if (error instanceof Error) {
        onHistoryCallback([], {
          noData: true,
        });
      }
    }
  },

  subscribeBars() {},

  unsubscribeBars() {},

  // Add other methods as needed (e.g., getQuotes, subscribeBars, etc.)
};
